<template lang="html">
	<!-- <div class="home-container">	</div> -->
	<el-container class="home-container">
		<aside class="menu-expanded" style="backgroud-color:#1f2d3d;width:180px;margin-right: 0px;padding-right: 0px;">
			<el-menu :default-active="$route.path" ref="bigmenu"
				style="width:180px;overflow-y: auto;overflow-x: hidden;" class="el-menu-vertical-demo"
				background-color="rgb(49 66 88)" unique-opened router>
				<template v-for="(item, index) in menulist">
					<el-submenu :index="index + ''" v-if="index > 0">
						<template slot="title"><i :class="item.iconCls"></i>{{ item.name }}</template>
						<template v-for="child in item.children">
							<el-menu-item @click="addRouter(child, child.path)" :index="child.path" :key="child.path">{{
				child.name }}</el-menu-item>
						</template>
					</el-submenu>
					<el-menu-item :index="item.children[0].path" :key="item.children[0].path" v-else>
						<i class="el-icon-menu"></i>
						<span slot="title" style="color:#ccc;">{{ item.children[0].name }}</span>
					</el-menu-item>
				</template>
			</el-menu>
		</aside>
		<el-container style="height: 100%;">
			<el-header height="50">
				<el-col :span="24" class="userinfo">
					<div style="display: flex;float:right;">
					  <div> 
						<span style="margin-left: 15px;">您好，欢迎登录答题系统</span>
						<span style="margin-left: 15px;">{{ getLogName() }} </span>
						<span style="margin-left: 15px;">{{sysUserName}}</span>
						<span style="margin-left: 15px;"><el-button type="info" @click.native="()=>{dialogPwdShow=true}" size="small">修改密码</el-button></span>
						<span style="margin-left: 15px;"><el-button type="danger" @click.native="logoutFun" size="small">安全退出</el-button></span>
				</div>
				</div>
				</el-col>
			</el-header>

			<el-main style="overflow: auto;">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="content-wrapper">
						<!-- <transition name="fade" mode="out-in"></transition> -->
						<!-- 路由匹配到的组件将显示在这里 -->
						<!-- <router-view></router-view> -->
						<el-tabs @tab-remove="removeTab" v-model="activeIndex" type="card" class="main-tab"
							@tab-click="clickTab">
							<el-tab-pane :key="item.name" v-for="item in openTab" :label="item.title" :name="item.name"
								:closable="item.closable"></el-tab-pane>
						</el-tabs>
						<div class="view-container">
							<router-view></router-view>
							<!-- <keep-alive :include="openTab.map(i => i.componentName)">
							
							</keep-alive> -->
						</div>
					</el-col>
				</div>
				<el-dialog title="修改密码" :visible.sync="dialogPwdShow" width="450px" :close-on-click-modal="false">
					<el-form  label-position="right" ref="addForm" :model="addForm" label-width="70px"
						class="postForm">
						<el-form-item label="原密码:" label-width="100px">
							<el-input v-model="addForm.oldPwd" auto-complete="off" class="formItem150" size="small" maxLength="50" />
						</el-form-item>
						<el-form-item label="新密码:" label-width="100px">
							<el-input v-model="addForm.newPwd" auto-complete="off" class="formItem150" size="small" maxLength="50" />
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="()=>{dialogPwdShow=false}" size="small">取 消</el-button>
						<el-button type="primary" @click="handlePwd()" size="small">确 定</el-button>
					</div>
				</el-dialog>
			</el-main>

		</el-container>
	</el-container>

</template>

<script>
import imagePath from '@/assets/logo.png';
export default {
	components: {},
	data() {
		return {
			activeIndex: 0,
			sysName: "",
			sysUserName: "系统管理员",
			imageSrc: imagePath,
			activepath: "",
			arry: [],
			treeArry: [],
			menulist: [],
			openTab: [
				{
					title: "工作台",
					name: "/backadmin/dashboard", //路由
					closable: false, //首页不可关闭
					componentName: "/dashboard" //组件名称用于keepalive缓存
				}
			],
			dialogPwdShow:false,
			addForm:{
				oldPwd:"",
				newPwd:"",
			}
		};
	},
	watch: {
		// $route(to, from) {
		//   this.activepath = to.path;
		// }
		$route(to, form) {

			//当路由更新进行tab切换
			var flag = false;
			// 当前页面菜单已打开,直接切换过去
			if (this.openTab) {
				for (let i = 0; i < this.openTab.length; i++) {
					if (
						to.path == this.openTab[i].name || to.path.includes(this.openTab[i].name)
					) {
						//openTab中已存在？
						this.activeIndex = this.openTab[i].name;
						flag = true;
						break;
					}
				}
			}

			// 打开新的页面tab
			if (!flag) {
				let obj = {
					title: to.name,
					name: to.path,
					closable: true,
					componentName: to.matched[1].components.default.name //路由只缓存到第1层，更深层的视图不考虑
				};
				this.activeIndex = to.path;
				this.openTab.push(obj);
			}
			console.log("openTab:", this.openTab)
		},
	},
	methods: {
		handlePwd(){
			let formData = this.$util.jsonToForm(this.addForm);
					this.$axios.post("/backadmin/editPwd", formData).then(res => {
						if (res.data.status == 0) {
							this.$message("修改成功!");
							this.dialogPwdShow=false
							this.addForm.oldPwd=""
							this.addForm.newPwd=""
						} else {
							this.$message(res.data.msg);
						}
					});
		},
		//退出登录
		logoutFun: function () {
			var _this = this;
			this.$confirm("确认安全退出吗?", "提示", {
				//type: 'warning'
			})
				.then(() => {
					localStorage.removeItem("token");
					_this.$router.push("/login");
				})
				.catch(() => { });
		},
		// 往tab页添加router
		addRouter(data, path) {
			console.log("addRouter:", data)
			const obj = Object.assign({}, data);
			obj.path = path;
			let add = true;
			for (let i = 0; i < this.arry.length; i++) {
				if (this.arry[i].path == obj.path) {
					add = false;
				}
			}
			console.log("addRouter-add:", add);
			if (add) {
				this.arry.push(obj);
			}
		},
		// 操作tab
		changeRouter(index) {
			this.$router.push(this.arry[index].path);
		},
		// 检查树结构是否包含当前节点
		checkContains(name) {
			return true;
			// return this.treeArry.includes(name);
		},
		// remove Tab
		removeTab2(index) {
			this.arry.splice(index, 1);
			if (index == 0) {
				this.$router.push(this.arry[0].path);
			} else {
				this.$router.push(this.arry[index - 1].path);
			}
		},
		removeTab(target) {
			// 删除的是当前选中的页面
			if (this.activeIndex === target) {
				this.openTab.forEach((item, index) => {
					if (item.name == target) {
						let nextTab = item[index + 1] || item[index - 1];
						if (nextTab) {
							this.activeIndex = nextTab.name;
						}
					}
				});
			}
			var i = 0;
			this.openTab.forEach((item, index) => {
				if (item.name == target) {
					return (i = index);
				}
			});
			this.openTab.splice(i, 1);

			// 更新路由
			this.$router.push({ path: this.openTab[this.openTab.length - 1].name });
		},
		clickTab(tab) {
			this.activeIndex = tab.paneName;
			this.$router.push({ path: this.activeIndex });
		},

	},
	created() {
		//this.checkTreeNode(this.treeData);
		if (this.userName) {
			this.sysUserName = this.userName;
		} else {
			this.sysUserName = "系统管理员";
		}

		let menuArr = JSON.parse(localStorage.getItem("MenuData"));
		let g_menulist = [];
		for (let n = 0; n < menuArr.length; n++) {
			if (menuArr[n].path === "/login") continue;
			let menuObj = {};
			menuObj.path = menuArr[n].path;
			menuObj.name = menuArr[n].name;
			menuObj.iconCls = menuArr[n].iconCls;
			menuObj.children = [];
			if (menuArr[n].children) {
				for (let k = 0; k < menuArr[n].children.length; k++) {
					menuObj.children.push({
						path: menuArr[n].children[k].path,
						name: menuArr[n].children[k].name,
					});
				}
			}
			g_menulist.push(menuObj);
		}
		this.menulist = g_menulist;

	},
	mounted() {
		this.sysUserName = this.getUserName()
	}
};
</script>

<style type="text/css" lang="scss" scoped>
@import "../assets/css/them.css";

.home-container {
	position: absolute;
	top: 0;
	bottom: 0;
	width: 100%;
	height: 100%;

	aside {
		flex: 0 0 180px;
		width: 180px;
		display: block;
		position: relative;
		//overflow-y: scroll;
		background-color: #324157 !important;

		.el-menu {
			height: 100%;

		}

		.collapsed {
			width: 60px;
			background: #033e6b;

			.item {
				position: relative;
			}

			.submenu {
				position: absolute;
				top: 0;
				left: 60px;
				z-index: 99999;
				height: auto;
				display: none;
			}
		}

		.menu-collapsed {
			flex: 0 0 60px;
			width: 60px;
		}

		.menu-expanded {
			//flex: 0 0 180px;
			//width: 230px;
			height: calc(100vh - 50px);
			overflow-x: hidden;
			overflow-y: auto;
			// border-top: solid #eddede 1px;
			// margin-top: 10px;
		}

		.single-menu {
			height: 40px;
			line-height: 40px;
			padding-left: 45px;
			color: #fff;
			background-color: #033e6b;
		}
	}

	.el-header {
		height: 40px;
		line-height: 40px;
		background: #edf2f7;
		//background: linear-gradient(to right, #adaaaa, #000);
		color: #000;
		margin: 0px;
		padding: 0px;
		//border-bottom: 1px solid #f3f1f1;

		.userinfo{
			color:#494848
		}

		.breadcrumb-container {
			margin-top: 20px;
			margin-left: 20px;
			color: #ccc;
		}
	}



	.el-main {
		padding: 0px;
		margin: 0px;
		overflow: hidden;

		.grid-content {
			padding: 0px;
			margin: 0px;
		}

		.content-container {
			flex: 1;
			overflow-y: scroll;
			padding: 20px;

			.content-wrapper {
				background-color: #fff;
				box-sizing: border-box;
			}
		}



	}


}
</style>

<style type="text/css">
.el-table thead {
	color: #909399;
	font-weight: 500;
}

.el-table .el-table__header th {
	word-break: break-word;
	background-color: #f8f8f9 !important;
	color: #515a6e;
	height: 25px;
	font-size: 13px;
}
/* .el-table th.el-table__cell {
    padding: 5px 0;
} */

html {
	height: 100%;
}

.dashboard-arrow .el-icon-arrow-down:before {
	content: none;
}

.el-form-item {
	margin-bottom: 12px;
}
</style>
